const theme = {
    background: {
        primary: '#fff',
        overlay: 'rgba(0,0,0,0.6)',
    },
    text: {
        font: 'Roboto, sans-serif',
        primary: '#fff',
        secondary: '#000',
        link: '#fff',
    },
};

export default theme;
